import {ReassignedTimelineEvent} from '@ots-frontend/ots-data';
import {Anchor, Text, ThemeIcon} from '@mantine/core'
import {useTranslation} from "react-i18next";
import {FormattedDateTime} from '../../date/FormattedDateTime/FormattedDateTime';
import {IconArrowsExchange} from "@tabler/icons-react";
import {Link} from "react-router-dom";

type Props = {
    event: ReassignedTimelineEvent;
};

export const ReassignedTimelineItemTitle = (props: {}) => {
    const {t} = useTranslation(["common"])
    return <>{t("common.entity.dispatchrequest.timeline.reassigned.title", "Reassigned")}</>
}

export const ReassignedTimelineItemBullet = (props: {}) => {
    return (
        <ThemeIcon
            size={22}
            color="dispatch-request-reassigned"
            radius="xl"
        >
            <IconArrowsExchange size={12}/>
        </ThemeIcon>
    )
}

export const ReassignedTimelineItem = (props: Props) => {
    const {event} = props;

    const {t} = useTranslation(["common"])

    return (
        <>
            <Text color="dimmed" size="sm">
                {t("common.entity.dispatchrequest.timeline.reassigned.summary", "{{personName}} reassigned the dispatch request to {{companyName}}.", {
                    personName: event.person ? event.person : t("common.shared.user", "User"),
                    companyName: event.company ? event.company : t("common.unknown", "Unknown")
                })}
            </Text>

            {event.reassignedToId &&
                <Anchor size={"xs"} component={Link} to={`/requests/profile?id=${event.reassignedToId}`}>
                    {t("common.action.view", "View")}
                </Anchor>
            }

            <Text size="xs" mt={4}>
                <FormattedDateTime date={event.date}/>
            </Text>
        </>
    );
};

ReassignedTimelineItem.Title = ReassignedTimelineItemTitle
ReassignedTimelineItem.Bullet = ReassignedTimelineItemBullet;
